import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Auth
export const exchangeSession = (sessionId) => 
  api.post('/auth/session', { session_id: sessionId });

export const getMe = () => api.get('/auth/me');

export const logout = () => api.post('/auth/logout');

export const adminLogin = (email, password) =>
  api.post('/auth/admin-login', { email, password });

// Events
export const getEvents = () => api.get('/events');

export const createEvent = (data) => api.post('/events', data);

export const deleteEvent = (eventId) => api.delete(`/events/${eventId}`);

export const getEvent = (eventId) => api.get(`/events/${eventId}`);

// Budgets
export const getBudgets = (params) => api.get('/budgets', { params });

export const createBudget = (data) => api.post('/budgets', data);

export const approveBudget = (budgetId, data) => 
  api.put(`/budgets/${budgetId}/approve`, data);

export const downloadBudgetPdf = (budgetId) => 
  api.get(`/budgets/${budgetId}/pdf`, { responseType: 'blob' });

// Expenses
export const getExpenses = (params) => api.get('/expenses', { params });

export const createExpense = (data) => api.post('/expenses', data);

export const parseExpenseText = (data) => api.post('/expenses/parse', data);

export const transcribeVoice = (formData) => api.post('/expenses/voice-transcribe', formData);

// Google Sheets
export const getSheetsStatus = () => api.get('/sheets/status');

export const configureSheetsId = (spreadsheetId) => 
  api.post('/sheets/configure', null, { params: { spreadsheet_id: spreadsheetId } });

// Admin
export const getUsers = () => api.get('/admin/users');

export const updateUserRole = (userId, role) => 
  api.put(`/admin/users/${userId}/role`, null, { params: { role } });

// Stats
export const getStats = () => api.get('/stats');

// Income & Transfers
export const getIncome = () => api.get('/income');

export const createIncome = (data) => api.post('/income', data);

export const getTransfers = () => api.get('/transfers');

export const createTransfer = (data) => api.post('/transfers', data);

export const getIncomeSummary = () => api.get('/income/summary');

// Categories
export const getCategories = () => api.get('/categories');

export const createCategory = (data) => api.post('/categories', data);

export const deleteCategory = (categoryId) => api.delete(`/categories/${categoryId}`);

export default api;
